import { ProductFeatures } from 'common/src/types/enums/ProductFeatures.enum';

import { IAuthorizationContext } from 'portal/src/auth/IAuthorizationContext';

export default function isEvChargingViewEnabled(
  context: IAuthorizationContext,
): boolean {
  return context.featureChecker.productFeatureEnabled(
    ProductFeatures.evCharging,
  );
}
